import {
  Alert,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { Circle } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { BUSINESS_ISSUE } from '../../../constants/strings';

const IncorrectOrderAlert = ({ errors, title = BUSINESS_ISSUE }) => (
  <Box sx={{ p: 2, pb: 0 }}>
    <Alert icon={false} severity='error'>
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 'bold',
          mb: 1,
        }}
      >
        {title}
      </Typography>
      <List>
        {errors.map((error, index) => (
          // NOTE: error can be the same (example: delivery or collection details)
          <ListItem key={`${error}${index}`} sx={{ padding: 0 }}>
            <ListItemIcon sx={{ minWidth: '15px' }}>
              <Circle fontSize='small' sx={{ width: '5px' }} />
            </ListItemIcon>
            <ListItemText sx={{ margin: 0 }}>
              <Typography variant='body2'>{error}</Typography>
            </ListItemText>
          </ListItem>
        ))}
      </List>
    </Alert>
  </Box>
);

IncorrectOrderAlert.propTypes = {
  title: PropTypes.string,
  errors: PropTypes.array,
};

export default IncorrectOrderAlert;
